module.exports = __webpack_public_path__ + "1cbbac8be03ee872ff721d9bb0cc4533.png";